import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

export const openSecondLevel = secondLevel => {
    const category = GA_EVENTS.navigation.category;
    const action = GA_EVENTS.navigation.actions.openSecondLevel;

    setBehaviourEvent({
        category,
        action,
        label: secondLevel,
    });
};
